var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('a',{staticClass:"button is-primary-ghost-small",on:{"click":_vm.goBack}},[_vm._v(_vm._s(_vm.backToByRouteNameTranslated[_vm.validPreviousState.name]))])])}
var staticRenderFns = []

export { render, staticRenderFns }